import type { RouteObject } from "react-router";

import { EstimatePage } from "./estimate-page.js";

/**
 * 見積書（ログイン不要。料金プランのページから開く）。<b>足したら paths/estimates.json にも足す。</b>
 * ポータルで足した画面で、今のアプリの URL と重ならない。
 */
export const estimateRoutes: RouteObject[] = [
    { path: "/Estimate", element: <EstimatePage /> },
];
